import image1 from './assets/images/trabajo1.jpg';
import image2 from './assets/images/trabajo2.jpg';
import image3 from './assets/images/trabajo3.jpg';
import image4 from './assets/images/trabajo4.jpg';
import image5 from './assets/images/trabajo5.jpg';
import image6 from './assets/images/trabajo6.jpg';
import image7 from './assets/images/trabajo7.jpg';
import image8 from './assets/images/trabajo8.jpg';
import image9 from './assets/images/trabajo9.jpg';
import image10 from './assets/images/trabajo10.jpg';
import image11 from './assets/images/trabajo11.jpg';
import image12 from './assets/images/trabajo12.jpg';
import image13 from './assets/images/trabajo13.jpg';
import image14 from './assets/images/trabajo14.jpg';
import image15 from './assets/images/trabajo15.jpg';
import image16 from './assets/images/trabajo16.jpg';
import image17 from './assets/images/trabajo17.jpg';
import image18 from './assets/images/trabajo18.jpg';
import image19 from './assets/images/trabajo19.jpg';
import image20 from './assets/images/trabajo20.jpg';
import image21 from './assets/images/trabajo21.jpg';
import image22 from './assets/images/trabajo22.jpg';
import image23 from './assets/images/trabajo23.jpg';
import image24 from './assets/images/trabajo24.jpg';
import image25 from './assets/images/trabajo25.jpg';
import image26 from './assets/images/trabajo26.jpg';
import image27 from './assets/images/trabajo27.jpg';
import image28 from './assets/images/trabajo28.jpg';
import image29 from './assets/images/trabajo29.jpg';
import image30 from './assets/images/trabajo30.jpg';
import image31 from './assets/images/trabajo31.jpg';
import image32 from './assets/images/trabajo32.jpg';
import image33 from './assets/images/trabajo33.jpg';
import image34 from './assets/images/trabajo34.jpg';
import image35 from './assets/images/trabajo35.jpg';
import image36 from './assets/images/trabajo36.jpg';
import image37 from './assets/images/trabajo37.jpg';
import image38 from './assets/images/trabajo38.jpg';
import image39 from './assets/images/trabajo39.jpg';
import image40 from './assets/images/trabajo30.jpg';
import image41 from './assets/images/trabajo41.jpg'

const listaDestacados = [
    image18,
    image29,
    image40,
    image26,
    image1,
    image9,
    image37

]

const listaCompleta = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6, 
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13, 
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20, 
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27, 
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34, 
    image35,
    image36,
    image37,
    image38,
    image39,
    image40,
    image41
]


export {listaDestacados, listaCompleta};